import TextField from "../components/common/TextField";
import { useFormik } from "formik";
import Button from "../components/common/Button";
import { showToast, ToastType } from "../utils/toast.utils";
import { RiderRequest, TransportType, TransportTypeLabels } from "../types";
import Dropdown from "../components/common/DropDown";
import { useCreateRiderRequestMutation } from "../store";
import { riderRequestSchema } from "../utils/validations";

const RiderRequestForm = () => {
  const [createRiderRequest, { isLoading }] = useCreateRiderRequestMutation();

  const handleSubmitForm = async (values: Omit<RiderRequest, "_id">) => {
    const result = await createRiderRequest(values);
    if (!result.error) {
      showToast("Demande envoyée avec succès", ToastType.SUCCESS);
    }
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormik<Omit<RiderRequest, "_id">>({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      city: "",
      transportType: "" as TransportType,
    },
    validationSchema: riderRequestSchema,
    onSubmit: handleSubmitForm,
  });

  return (
    <form
      className="w-full grid grid-cols-2 gap-4"
      onSubmit={handleSubmit}
      id="rider-request-form"
    >
      <TextField
        id="firstName"
        value={values.firstName}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Prénom"
      />
      <TextField
        id="lastName"
        value={values.lastName}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Nom"
      />
      <TextField
        id="email"
        value={values.email}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Email"
      />
      <TextField
        id="phone"
        value={values.phone}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        errors={errors}
        placeholder="Téléphone"
      />
      <div className="col-span-2">
        <TextField
          id="city"
          value={values.city}
          onChange={handleChange}
          onBlur={handleBlur}
          touched={touched}
          errors={errors}
          placeholder="Ville"
        />
      </div>

      <div className="col-span-2">
        <Dropdown
          id="transportType"
          placeholder="Votre moyen de transport"
          options={Object.values(TransportType).map((key) => ({
            value: key,
            label: TransportTypeLabels[key],
          }))}
          value={values.transportType}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          errors={errors}
          touched={touched}
          isFetching={isLoading}
        />
      </div>

      <div className="col-span-2 flex justify-center mt-4">
        <Button
          className="w-1/2 justify-center font-bold py-2 bg-primary rounded text-white"
          disabled={isSubmitting || isLoading}
          type="submit"
        >
          Envoyer
        </Button>
      </div>
    </form>
  );
};

export default RiderRequestForm;
